<template>
  <div class="project-entry breakdown-popup">
    <div class="background-click-detector" @click="closePopup()"></div>
    <div class="project-entry-wrapper">
      <div class="popup-exit" @click="closePopup">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xmlns:avocode="https://avocode.com/"
          id="SVGDoc"
          width="22"
          height="27"
          version="1.1"
          viewBox="0 0 22 27"
        >
          <defs />
          <desc>Generated with Avocode.</desc>
          <g>
            <g>
              <title>close</title>
              <path
                d="M9.15986,25.54362c0,0.80252 -0.62895,1.45636 -1.40274,1.45636h-6.35636c-0.77379,0 -1.40274,-0.65384 -1.40274,-1.45636v-23.31371c0,-0.80309 0.62895,-1.45683 1.40274,-1.45683h6.35636c0.77379,0 1.40274,0.65374 1.40274,1.45683c0,0.80328 -0.62895,1.45693 -1.40274,1.45693h-4.95481v20.39928h4.95481c0.77379,0 1.40274,0.65374 1.40274,1.4575zM21.87376,13.93016c0.02015,0.35725 -0.12231,0.74883 -0.39876,1.03903l-4.80282,4.15678c-0.22542,0.23775 -0.58031,0.39129 -0.9588,0.39129c-0.37885,0 -0.73373,-0.15354 -0.99945,-0.43163c-0.54467,-0.56829 -0.54467,-1.49174 0.00119,-2.05879l1.94395,-1.68324h-9.6947c-0.77379,0 -1.40393,-0.65355 -1.40393,-1.45731c0,-0.80252 0.63014,-1.45636 1.40393,-1.45636h9.66263l-1.87135,-1.61791c-0.5852,-0.60673 -0.58639,-1.53074 -0.04172,-2.09885c0.26572,-0.27752 0.6206,-0.43068 0.99945,-0.43068c0.37849,0 0.73338,0.15249 0.99909,0.43068l4.71973,4.07524c0.31924,0.33197 0.4617,0.72327 0.44155,1.14174z"
                fill="#7b7b8a"
                fill-opacity="1"
              />
            </g>
          </g>
        </svg>
      </div>
      <div class="project-content-wrapper">
        <div class="entry-title">
          {{ $t("forms.cost_sheet.breakdown.form.title") }}
        </div>
        <div class="form-input-wrapper form-date">
          <label class="form-label" for="vrijeme-pocetka">
            <span>{{ $t("forms.cost_sheet.breakdown.form.date") }}</span>
          </label>
          <input
            :class="['form-input', 'date-input']"
            :style="stavka.date == '' ? 'color:#777777' : ''"
            type="date"
            id="datum-zavrsetka"
            ref="datumZavrsetka"
            name="datum-zavrsetka"
            v-model="stavka.date"
          />
        </div>
        <div class="form-input-wrapper">
          <label class="form-label">
            <span>{{ $t("forms.cost_sheet.breakdown.form.description") }}</span>
          </label>
          <textarea class="form-textarea" v-model="stavka.description" />
        </div>
        <div class="project-dropdowns clanovi-tima-wrapper">
          <form-autocomplete
            :label="$t('forms.cost_sheet.breakdown.form.osoba_lbl')"
            type="main_nositelj"
            id="clanovi-tima-single"
            ref="zaduzenici"
            :placeholder="$t('forms.cost_sheet.breakdown.form.osoba_plh')"
            :items="second_ac_arr"
          ></form-autocomplete>
          <autocomplete-multiple
            label="Ostatak tima"
            type="other_included"
            id="clanovi-tima-eventi"
            ref="ostali"
            :placeholder="$t('forms.event.members_plh')"
            :items="second_ac_arr"
          ></autocomplete-multiple>
          <!-- <div class="wrapp-dodijeli">
                <div class="archived-destroyed-element sve" @click="assignToMe">Dodijeli meni</div>
                <div class="archived-destroyed-element unisti" @click="assignToEveryone">Dodijeli svima</div>
                </div> -->
        </div>
        <div class="two-row-elements">
          <div class="form-input-wrapper">
            <label class="form-label">
              <span>{{ $t("forms.cost_sheet.breakdown.form.idx") }}</span>
            </label>
            <CustomDropdown
              :id="'drop_sifarnik_type'"
              v-model="stavka.belonging_satnica_id"
              :drop_items="drop_items"
            />
          </div>
          <div class="form-input-wrapper">
            <label class="form-label">
              <span>{{
                $t("forms.cost_sheet.breakdown.form.tip_usluge")
              }}</span>
            </label>
            <CustomDropdown
              :id="'drop_service_type'"
              v-model="stavka.service_type_id"
              :drop_items="service_types"
            />
          </div>
        </div>
        <div class="three-row-elements">
          <div class="form-input-wrapper">
            <label class="form-label">
              <span>{{ $t("forms.cost_sheet.breakdown.form.satnica") }}</span>
            </label>
            <input
              type="text"
              class="form-input"
              v-model="stavka.satnica"
              @input="calculateIznos(stavka)"
              oninput="this.value = this.value.replace(',','.').replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
            />
          </div>
          <div class="form-input-wrapper">
            <label class="form-label">
              <span>{{ $t("forms.cost_sheet.breakdown.form.used_time") }}</span>
            </label>
            <div class="form-input total-time-input">
              <div class="time-wrapper">
                <input
                  type="number"
                  min="0"
                  max="999"
                  v-model="stavka.time_h"
                  @input="calculateIznos(stavka)"
                />
                <span> h</span>
              </div>
              <div class="vertical-divider"></div>
              <div class="time-wrapper">
                <input
                  type="number"
                  min="0"
                  max="60"
                  v-model="stavka.time_min"
                  @input="calculateIznos(stavka)"
                />
                <span> min</span>
              </div>
            </div>
          </div>
          <div class="form-input-wrapper">
            <label class="form-label"
              ><span>{{
                $t("forms.cost_sheet.breakdown.form.value")
              }}</span></label
            >
            <input
              type="text"
              disabled
              class="form-input"
              v-model="stavka.iznos"
            />
          </div>
        </div>
        <div class="button-create-wrapper">
          <div @click="closePopup" class="button-default button-create">
            <span>{{ $t("repetitive.save") }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import formAutocomplete from "@/components/formElements/formAutocompleteSingle.vue";
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import formAutocompleteMultiple from "@/components/formElements/formInputAutocomplete.vue";

export default {
  components: {
    formAutocomplete,
    CustomDropdown,
    "autocomplete-multiple": formAutocompleteMultiple,
  },
  props: [
    "is_edit",
    "stavka",
    "team_members",
    "edit_team_members",
    "drop_items",
    "service_types",
  ],
  methods: {
    calculateIznos(stavka) {
      const h = stavka.time_h != "" ? stavka.time_h : 0;
      const min = stavka.time_min != "" ? stavka.time_min / 60 : 0;
      stavka.iznos = h * stavka.satnica + min * stavka.satnica;
      stavka.iznos = stavka.iznos.toFixed(2);
    },
    closePopup() {
      this.$emit("closeMe");
    },
    getDate(date) {
      return moment(date).format("DD.MM.YYYY.");
    },

    filter_both() {
        this.second_ac_arr = [...this.team_members];
      if (this.$refs.ostali.results_final.length > 0 ) {
        console.log(this.$refs.ostali.results_final)
        
        this.second_ac_arr = this.second_ac_arr.filter(
          (p) => !this.$refs.ostali.results_final.map((p) => parseInt(p.UID)).includes(p.link)
        );
        console.log(this.second_ac_arr,"Filtered arr")
      }
        this.second_ac_arr = this.second_ac_arr.filter(
          (p) => p.link != this.stavka.osobe.results_final.uid
        );
    },
  },
  data() {
    return {
      team_members_copy: [],

      first_ac_arr: [],
      second_ac_arr: [],
      previous_multiple: [],
    };
  },
  watch: {
    // Watch for changes in single selection (zaduzenici) and filter multi-selection options accordingly
    "stavka.osobe": {
      handler(newVal) {
        if (newVal) {
            this.filter_both()
        }
      },
      immediate: true,
      deep: true,
    },
    "stavka.multiple_odvjetnik": {
      handler(newVal) {
        if (newVal) {
            this.filter_both()
        }
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    if (this.stavka.multiple_odvjetnik) {
      this.previous_multiple = [
        ...this.stavka.multiple_odvjetnik.results_final,
      ];
    }
    this.first_ac_arr = [...this.team_members];
    this.second_ac_arr = [...this.team_members];

    this.stavka.multiple_odvjetnik = this.$refs.ostali.$data;
    this.stavka.osobe = this.$refs.zaduzenici.$data;

    if (this.is_edit) {
      this.$refs.zaduzenici.results_final = this.edit_team_members;
      this.$refs.ostali.results_final = this.previous_multiple;

      if (this.previous_multiple) {
        this.second_ac_arr = this.second_ac_arr.filter(
          (p) => !this.previous_multiple.map((p) => p.UID).includes(p.link)
        );
        this.second_ac_arr = this.second_ac_arr.filter(
          (p) => p.link != this.edit_team_members.uid
        );
      }
    }
  },
};
</script>
